import {noop} from '@github-ui/noop'
import {LinkExternalIcon} from '@primer/octicons-react'

import {IssueTemplateItem} from './IssueTemplateItem'
import type {RepositoryContactLinkNode} from './template-list-query-types'

export type ExternalLinkTemplateRowFragment = Pick<RepositoryContactLinkNode, 'about' | 'url' | 'name'>

type ExternalLinkTemplateRowProps = {
  repositoryContactLink: ExternalLinkTemplateRowFragment
}

export const ExternalLinkTemplateRow = ({repositoryContactLink}: ExternalLinkTemplateRowProps): React.ReactElement => {
  return (
    <IssueTemplateItem
      filename={repositoryContactLink.name}
      onTemplateSelected={noop}
      name={repositoryContactLink.name}
      link={repositoryContactLink.url}
      about={repositoryContactLink.about}
      externalLink
      trailingIcon={<LinkExternalIcon />}
    />
  )
}
